import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import moment from 'moment'
import datePicker from '../../component/dccore-form/datePicker.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import multimedia from '../../component/dccore-form/multimedia.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import History from './history.vue'
import Checkbox from '@component/dccore-form/checkbox.vue'

if ($('#discountcode_form').length) {
  const DISCOUNT_TYPE_AMOUNT = 'AMOUNT'
  const DISCOUNT_TYPE_PERCENTAGE = 'PERCENTAGE'

  Vue.use(VueResource)
  new Vue({
    el: '#discountcode_form',
    components: {
      RingLoader,
      datePicker,
      moment,
      TextInput,
      NumberInput,
      multimedia,
      Singleselect,
      History,
      Checkbox
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        entity: {
          type: 'UNIVERSAL',
          discountType: DISCOUNT_TYPE_PERCENTAGE,
          code: '',
          dateFrom: new moment(),
          dateTo: new moment().add(1, 'days'),
          excludeLoyaltyProgram: [],
          minOrderPrice: null,
          firstOrderOnly: false,
          workName: '',
        },
        generator: {
          discountType: DISCOUNT_TYPE_PERCENTAGE,
          minOrderPrice: null,
          firstOrderOnly: false,
        },
        options: {
          brands: [],
          errors: {},
          generator: {
            errors: {}
          },
          types: [],
          discountTypes: [
            {
              id: DISCOUNT_TYPE_PERCENTAGE,
              name: Translator.trans('discount_code.entity.discount_types.percentage'),
            },
            {
              id: DISCOUNT_TYPE_AMOUNT,
              name: Translator.trans('discount_code.entity.discount_types.amount'),
            }
          ],
          categories: [],
        }
      },
      entityId: null,
      loyaltyProgramsUniversal: {
        oldStager: 0,
        menuRating: 0,
        jointDeliveries: 0
      },
      loyaltyProgramsOnce: {
        oldStager: 0,
        menuRating: 0,
        jointDeliveries: 0
      },
    },
    watch: {
      'form.entity.type': function (newValue) {
        if (newValue === 'ONCE') {
          this.form.entity.dateFrom = null
          this.form.entity.dateTo = null
        }
      }
    },
    mounted () {
      this.loading++

      this.getBrands()
      this.getDiscountCodeCategories()

      if ($('#entity_id').length) {
        this.getTypes()
        this.entityId = $('#entity_id').val()
        this.getDiscountCode()
      }

      this.loading--
    },
    methods: {
      getBrands() {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getDiscountCodeCategories() {
        let url = Routing.generate('api_get_tags', { 'type': 'discount_code_category', context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.categories = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      createDiscountCode (redirect) {
        let url = Routing.generate('api_post_discountcode')
        this.form.options.errors = {}

        /** lost reference */
        let data = {
          data: Object.assign({}, this.form.entity)
        }

        delete data.data.type

        data.data.excludeLoyaltyProgram = [
          {
            'oldStager': this.loyaltyProgramsUniversal.oldStager ? 1 : 0,
            'menuRating': this.loyaltyProgramsUniversal.menuRating ? 1 : 0,
            'jointDeliveries': this.loyaltyProgramsUniversal.jointDeliveries ? 1 : 0
          }
        ]

        this.loading++
        this.$http.post(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('discount_code_grid'))
          } else {
            toastr.success(Translator.trans('form.created'))
          }
          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateDiscountCode (redirect) {
        this.loading++
        let url = Routing.generate('api_patch_discountcode', {
          id: this.entityId
        })
        this.form.options.errors = {}
        let data = {
          data: this.form.entity
        }
        delete data.data.createdAt

        if (this.form.entity.type === 'UNIVERSAL') {
          data.data.excludeLoyaltyProgram = [
            {
              'oldStager': this.loyaltyProgramsUniversal.oldStager ? 1 : 0,
              'menuRating': this.loyaltyProgramsUniversal.menuRating ? 1 : 0,
              'jointDeliveries': this.loyaltyProgramsUniversal.jointDeliveries ? 1 : 0
            }
          ]
        } else if (this.form.entity.type === 'ONCE') {
          data.data.excludeLoyaltyProgram = [
            {
              'oldStager': this.loyaltyProgramsOnce.oldStager ? 1 : 0,
              'menuRating': this.loyaltyProgramsOnce.menuRating ? 1 : 0,
              'jointDeliveries': this.loyaltyProgramsOnce.jointDeliveries ? 1 : 0
            }
          ]
        }

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('discount_code_grid'))
          } else {
            toastr.success(Translator.trans('form.updated'))
            this.form.options.errors = {}
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      getDiscountCode () {
        this.loading++
        let url = Routing.generate('api_get_discountcode', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.form.entity = response.data

          if (this.form.entity.type === 'UNIVERSAL') {
            this.loyaltyProgramsUniversal = response.data.excludeLoyaltyProgram
          } else if (this.form.entity.type === 'ONCE') {
            this.loyaltyProgramsOnce = response.data.excludeLoyaltyProgram
          }

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getTypes () {
        this.loading++
        let url = Routing.generate('api_get_discountcodes_types')

        this.$http.get(url).then(response => {
          this.form.options.types = response.data

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      generateCodes () {
        this.form.generator.excludeLoyaltyProgram = [
          {
            'oldStager': this.loyaltyProgramsOnce.oldStager ? 1 : 0,
            'menuRating': this.loyaltyProgramsOnce.menuRating ? 1 : 0,
            'jointDeliveries': this.loyaltyProgramsOnce.jointDeliveries ? 1 : 0
          }
        ]

        let url = Routing.generate('api_post_discountcode_generator')

        let data = {
          data: this.form.generator
        }
        this.form.options.generator.errors = {}
        this.loading++
        this.$http.post(url, data).then(() => {
          $(location).attr('href', Routing.generate('discount_code_grid'))
          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options.generator)
        })
      }
    }
  })

}
